import routerOptions0 from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.19.2_@parcel+watcher@2.5.1_@types+node@24.6.2_@vue+compiler-sfc@3.5.22_db0@0.3.4_68b221aa5062d698802a355367b2505a/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}